import React, { useState, useEffect } from "react";
import { Button, Grid } from "@mui/material";
import { Form, Spinner } from "react-bootstrap";

const LoginUserScreen = () => {
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [categorys, setCategorys] = useState([]);
  const [passwordOld, setPasswordOld] = useState("");
  const [passwordOldValid, setPasswordValidOld] = useState(false);

  const [passwordNew, setPasswordNew] = useState("");
  const [passwordNewValid, setPasswordNewValid] = useState(false);

  const [passwordConfirm, setConfirmPassword] = useState("");
  const [passwordConfirmValid, setPasswordConfirmValid] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [login, setLogin] = useState(true);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    officialEmail: "",
    contactNumber: "",
    organizationName: "",
    numberOfEmployees: "100",
    city: "",
    country: "",
    companyDomain: "",
    category: "",
    awarenessType: "General Awareness",
    trainingTimeframe: "2 to 4 weeks",
    language: "English",
    existingPlatform: "No",
    platformIssues: "",
    additionalInfo: "",
  });

  useEffect(() => {
    fetchCategorys();
  }, []);

  const fetchCategorys = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch("https://beiguru.co.in/trial-category", requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => setCategorys(result))
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setEmailValid(validateEmail(emailValue));
  };

  const handlePasswordChange = (e) => {
    const passwordValue = e.target.value;
    setPassword(passwordValue);
    setPasswordValid(passwordValue.length >= 9); // Example: Password must be at least 6 characters
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (emailValid && passwordValid) {
      setIsLoading(true);
      console.log("Form submitted:", { email, password });
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          email: email,
          password: password,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        var response = await fetch(
          "https://beiguru.co.in/admin/login-employee",
          requestOptions
        );
        if (response.ok) {
          const data = await response.json();
          const { token, employee } = data;
          console.log(employee);
          localStorage.setItem("token", token);
          localStorage.setItem("user", "true");
          localStorage.setItem("userId", employee._id);
          localStorage.setItem("score", employee.score);
          localStorage.setItem("avatar", employee.avatar);
          localStorage.setItem("level", employee.level);
          localStorage.setItem(
            "department",
            employee.department ? employee.department.name : ""
          );
          localStorage.setItem(
            "departmentID",
            employee.department ? employee.department._id : ""
          );
          localStorage.setItem(
            "designation",
            employee.designation ? employee.department : ""
          );
          localStorage.setItem("firstName", employee.firstName);
          localStorage.setItem("lastName", employee.lastName);
          localStorage.setItem(
            "phoneNumber",
            employee.phoneNumber ? employee.phoneNumber : ""
          );
          localStorage.setItem("company", employee.company._id);
          localStorage.setItem("companyName", employee.company.name);
          localStorage.setItem("companyLogo", employee.company.logo);
          localStorage.setItem("email", employee.email);
          setIsLoading(false);
          if (employee.passwordReset) {
            setChangePassword(true);
          } else {
            localStorage.setItem("loggedIn", "true");
            window.location.reload();
          }
        } else {
          if (response.status == 403) {
            localStorage.setItem("loggedIn", "false");
            setIsLoading(false);
            alert(
              "This account or organization is disabled, kindly contact support!"
            );
            console.error("Login failed");
          } else {
            localStorage.setItem("loggedIn", "false");
            setIsLoading(false);
            alert("Incorrect email or password. Please try again.");
            console.error("Login failed");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
        localStorage.setItem("loggedIn", "false");
        setIsLoading(false);
        alert("An error occurred during login. Please try again later.");
      }
    } else {
      alert("Please fill in all fields correctly.");
    }
  };

  const validateEmail = (email) => {
    // Simple email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <Grid
      container
      spacing={0}
      style={{
        height: "100vh",
        backgroundColor: "white",
        fontFamily: "Poppins",
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
      }}
    >
      <Grid
        item
        style={{
          borderRadius: "20px",
          width: "35%",
          height: "70%",
          backgroundColor: "white",
          overflow: "auto",
          boxShadow: "1px 0px 5px rgba(200, 200, 200, 0.9)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          /* Hide scrollbar for IE, Edge and Firefox */
          msOverflowStyle: "none" /* IE and Edge */,
          scrollbarWidth: "none" /* Firefox */,
        }}
      >
        {changePassword ? (
          <Grid
            item
            xs={8}
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img
              src={require("../assets/coloredLogo.png")}
              alt="Login"
              style={{ width: "70%", height: "auto", marginBottom: "20px" }}
            />
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                fontFamily: "Noto Sans",
                margin: "0px",
                padding: "0px",
              }}
            >
              Change Password
            </p>
            <div style={{ height: "15px" }} />
            <Form
              style={{ fontFamily: "Noto Sans" }}
              className="w-100"
              onSubmit={async (e) => {
                e.preventDefault();
                if (
                  passwordOld.trim() === "" ||
                  passwordNew.trim() === "" ||
                  passwordConfirm.trim() === ""
                ) {
                  alert("Password fields cannot be empty!");
                  return;
                }
                if (passwordNew !== passwordConfirm) {
                  alert("New and confirm password do not match!");
                  return;
                }
                setIsLoading(true);
                try {
                  const token = localStorage.getItem("token");
                  const userId = localStorage.getItem("userId");
                  if (!token || !userId) {
                    console.error("Token or userId not found in localStorage");
                    alert("Token or userId not found in localStorage");
                    return;
                  }

                  const response = await fetch(
                    "https://beiguru.co.in/admin/change-employee-password",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                      },
                      body: JSON.stringify({
                        currentPassword: passwordOld,
                        employeeID: userId,
                        newPassword: passwordNew,
                      }),
                    }
                  );

                  if (response.ok) {
                    localStorage.setItem("loggedIn", "true");
                    window.location.reload();
                  } else {
                    alert("Change password request failed:", response.status);
                    return;
                  }
                } catch (error) {
                  alert("Change password failed:", error);
                } finally {
                  setIsLoading(false);
                }
              }}
            >
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label
                  htmlFor="inputPassword5"
                  style={{ fontWeight: "500", borderRadius: "20px" }}
                >
                  Password
                </Form.Label>
                <Form.Control
                  type="password"
                  id="inputPassword5"
                  aria-describedby="passwordHelpBlock"
                  style={{
                    borderRadius: "20px",
                    height: "50px",
                    width: "100%",
                    padding: "10px",
                    boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                  value={passwordOld}
                  onChange={(e) => {
                    const passwordValue = e.target.value;
                    setPasswordOld(passwordValue);
                    setPasswordValidOld(passwordValue.length >= 9); // Example: Password must be at least 6 characters
                  }}
                  isInvalid={passwordOld !== "" && !passwordOldValid}
                />
                <Form.Control.Feedback type="invalid">
                  Password must be at least 9 characters long.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label
                  htmlFor="inputPassword5"
                  style={{ fontWeight: "500", borderRadius: "20px" }}
                >
                  New Password
                </Form.Label>
                <Form.Control
                  type="password"
                  id="inputPassword5"
                  aria-describedby="passwordHelpBlock"
                  style={{
                    borderRadius: "20px",
                    height: "50px",
                    width: "100%",
                    padding: "10px",
                    boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                  value={passwordNew}
                  onChange={(e) => {
                    const passwordValue = e.target.value;
                    setPasswordNew(passwordValue);
                    setPasswordNewValid(passwordValue.length >= 9); // Example: Password must be at least 6 characters
                  }}
                  isInvalid={passwordNew !== "" && !passwordNewValid}
                />
                <Form.Control.Feedback type="invalid">
                  Password must be at least 9 characters long.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label
                  htmlFor="inputPassword5"
                  style={{ fontWeight: "500", borderRadius: "20px" }}
                >
                  Confirm Password
                </Form.Label>
                <Form.Control
                  type="password"
                  id="inputPassword5"
                  aria-describedby="passwordHelpBlock"
                  style={{
                    borderRadius: "20px",
                    height: "50px",
                    width: "100%",
                    padding: "10px",
                    boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                  value={passwordConfirm}
                  onChange={(e) => {
                    const passwordValue = e.target.value;
                    setConfirmPassword(passwordValue);
                    setPasswordConfirmValid(passwordValue.length >= 9); // Example: Password must be at least 6 characters
                  }}
                  isInvalid={passwordConfirm !== "" && !passwordConfirmValid}
                />
                <Form.Control.Feedback type="invalid">
                  Password must be at least 9 characters long.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                sx={{
                  borderRadius: "20px",
                  height: "50px",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "black",
                  color: "white",
                  fontFamily: "Noto Sans",
                  fontSize: "18px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#574dcf",
                  },
                }}
                className="w-100"
                variant="contained"
                color="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}{" "}
                Change Password
              </Button>
            </Form>
          </Grid>
        ) : forgotPassword ? (
          <Grid
            item
            xs={8}
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img
              src={require("../assets/coloredLogo.png")}
              alt="Login"
              style={{ width: "70%", height: "auto", marginBottom: "20px" }}
            />
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                fontFamily: "Noto Sans",
                margin: "0px",
                padding: "0px",
              }}
            >
              Forgot Password
            </p>
            <div style={{ height: "15px" }} />
            <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Email address
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="name@example.com"
                  className="w-100"
                  style={{
                    borderRadius: "20px",
                    height: "50px",
                    width: "100%",
                    padding: "10px",
                    boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                  value={email}
                  onChange={handleEmailChange}
                  isInvalid={email !== "" && !emailValid}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid email address.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                sx={{
                  borderRadius: "20px",
                  height: "50px",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "black",
                  color: "white",
                  fontFamily: "Noto Sans",
                  fontSize: "18px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#574dcf",
                  },
                }}
                className="w-100"
                variant="contained"
                color="primary"
                type="submit"
                onClick={(event) => {
                  event.preventDefault();
                  if (!email) {
                    alert("Please enter an email!");
                    return;
                  }
                  const myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");

                  const raw = JSON.stringify({
                    email: email,
                  });

                  const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };
                  fetch(
                    "https://beiguru.co.in/admin/forgot-password",
                    requestOptions
                  )
                    .then((response) => {
                      if (response.ok) {
                        alert(
                          "A new temporary password has been sent in email. Kindly check your email for details."
                        );
                        setForgotPassword(false);
                      } else {
                        alert("This Email ID does not exist.", response.status);
                        return;
                      }
                    })
                    .then((result) => console.log(result))
                    .catch((error) => console.error(error));
                }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}{" "}
                Reset Password
              </Button>
            </Form>
            <div
              style={{ flexDirection: "row", display: "flex", margin: "15px" }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans",
                  marginRight: "5px",
                }}
                onClick={() => {
                  setForgotPassword(false);
                }}
              >
                Back to Login!
              </p>
            </div>
          </Grid>
        ) : (
          <Grid
            item
            xs={8}
            style={{
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img
              src={require("../assets/coloredLogo.png")}
              alt="Login"
              style={{
                width: "70%",
                height: "auto",
                margin: "0px",
                padding: "0px",
              }}
            />
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                fontFamily: "Noto Sans",
                margin: "0px",
                padding: "0px",
              }}
            >
              Login to your account!
            </p>
            <div style={{ height: "15px" }} />
            <Form
              style={{ fontFamily: "Noto Sans" }}
              className="w-100"
              onSubmit={handleSubmit}
            >
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Email address
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="name@example.com"
                  className="w-100"
                  style={{
                    borderRadius: "20px",
                    height: "50px",
                    width: "100%",
                    padding: "10px",
                    boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                  value={email}
                  onChange={handleEmailChange}
                  isInvalid={email !== "" && !emailValid}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid email address.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label
                  htmlFor="inputPassword5"
                  style={{ fontWeight: "500", borderRadius: "20px" }}
                >
                  Password
                </Form.Label>
                <Form.Control
                  type="password"
                  id="inputPassword5"
                  aria-describedby="passwordHelpBlock"
                  style={{
                    borderRadius: "20px",
                    height: "50px",
                    width: "100%",
                    padding: "10px",
                    boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                  value={password}
                  onChange={handlePasswordChange}
                  isInvalid={password !== "" && !passwordValid}
                />
                <Form.Control.Feedback type="invalid">
                  Password must be at least 9 characters long.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                sx={{
                  borderRadius: "20px",
                  height: "50px",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "black",
                  color: "white",
                  fontFamily: "Noto Sans",
                  fontSize: "18px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "grey",
                  },
                }}
                className="w-100"
                variant="contained"
                color="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}{" "}
                Login
              </Button>
            </Form>
            <div
              style={{ flexDirection: "row", display: "flex", margin: "15px" }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans",
                  marginRight: "5px",
                }}
              >
                Forgot your password?{" "}
              </p>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans",
                  color: "red",
                }}
                onClick={() => {
                  setForgotPassword(true);
                }}
              >
                Click here!
              </p>
            </div>
            <div
              style={{ flexDirection: "row", display: "flex", margin: "15px" }}
            >
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans",
                  marginRight: "5px",
                }}
              >
                Software Version:{" "}
              </p>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans",
                  color: "red",
                }}
                onClick={() => { }}
              >
                v2.0
              </p>
            </div>
            {/* <div style={{ flexDirection: 'row', display: 'flex', margin: '15px' }}>
                        <p style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: 'Noto Sans', marginRight: '5px' }}>Want to test our services?</p>
                        <p style={{ fontSize: '14px', fontWeight: 'bold', fontFamily: 'Noto Sans', color: 'red' }} onClick={() => {
                            setLogin(false);
                        }}>Register Now!</p>
                    </div> */}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default LoginUserScreen;
